import script from "./modal-privacy-policy.vue?vue&type=script&setup=true&lang=js"
export * from "./modal-privacy-policy.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__